"use strict";
/* eslint-disable no-dupe-keys */
module.exports = {
    supplierSalesReport: 'Avräkning' || 'supplierSalesReport',
    setOwningSupplierOrganization: 'Sätt ägande organisation' || 'setOwningSupplierOrganization',
    upsert: '' || 'upsert',
    upsertWhenEmpty: '' || 'upsertWhenEmpty',
    updateWhenEmpty: '' || 'updateWhenEmpty',
    update: '' || 'update',
    id: 'Identitet' || 'id',
    reportNumber: 'Avräkning' || 'reportNumber',
    reportState: 'Status' || 'reportState',
    reportStates: {
        created: 'Skapad' || 'created',
        sentToSupplier: 'Skickad' || 'sentToSupplier',
        invoiceRecievedFromSupplier: 'Mottagen av Flaivy' || 'invoiceRecievedFromSupplier',
        invoiceCompleted: 'Bokförd' || 'invoiceCompleted',
    },
    cancelled: 'Makulerad' || 'cancelled',
    supplier: 'Leverantör' || 'supplier',
    invoice: 'Faktura' || 'invoice',
    startDate: 'Rapportens startdatum' || 'startDate',
    endDate: 'Rapportens slutdatum' || 'endDate',
    totalExcludingVAT: 'Netto' || 'totalExcludingVAT',
    totalAlcoholTax: 'Total alkoholskatt' || 'totalAlcoholTax',
    totalPostponedAlcoholTax: 'Total EMCS alkoholskatt' || 'totalPostponedAlcoholTax',
    totalInvoicedBySupplier: 'Belopp som leverantören har fakturerat' || 'totalInvoicedBySupplier',
    totalCommission: 'Total provision' || 'totalCommission',
    totalAdjustment: 'Total justering' || 'totalAdjustment',
    total: 'Total moms' || 'total',
    totalToBillExcludingVAT: 'Total moms' || 'totalToBillExcludingVAT',
    totalToBill: 'Belopp att fakturera' || 'totalToBill',
    serviceAgreement: 'Serviceavtal' || 'serviceAgreement',
    serviceAgreements: {
        'v2.5': 'v2.5 - minimum serviceavgift och taggade kunder - Använder order och reklamationer' ||
            'v2.5',
        v3: 'v3' || 'v3',
    },
    totalCost: 'Totalkostnad för leverantören över perioden' || 'totalCost',
    owningSupplierOrganizationId: 'owningSupplierOrganizationId' || 'owningSupplierOrganizationId',
    supplierSalesReportRows: {
        id: 'Identitet' || 'id',
        article: 'Artikel' || 'article',
        deliveredQuantity: 'Levererat antal' || 'deliveredQuantity',
        name: 'Produktnamn' || 'name',
        price: 'pris' || 'price',
        totalExcludingVAT: 'Total (excl moms)' || 'totalExcludingVAT',
        discount: 'Rabatt' || 'discount',
        total: 'Total' || 'total',
        totalAlcoholTax: 'Total alkoholskatt' || 'totalAlcoholTax',
        totalPostponedAlcoholTax: 'Total EMCS alkoholskatt' || 'totalPostponedAlcoholTax',
        totalCommission: 'Total provision för varan' || 'totalCommission',
        commissionPercentage: 'Provisionsprocent' || 'commissionPercentage',
        section: 'Sektion' || 'section',
        sections: {
            sales: 'Försäljning' || 'sales',
            systembolaget: 'Försäljning till Systembolaget' || 'systembolaget',
            adjustments: 'Avgifter och justeringar' || 'adjustments',
        },
        invoiceDetails: 'Spårning' || 'invoiceDetails',
        orderDetails: 'Spårning' || 'orderDetails',
        complaintDetails: 'Spårning' || 'complaintDetails',
        isAdjustment: 'Justeringsrad' || 'isAdjustment',
    },
};
